import React from 'react';
import THead from './Partials/THead/index.jsx';
import TBody from './Partials/TBody/index.jsx';

class Table extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        const { id, dataRows,dataColumns, keyRow,onSelectedRow, rowsSelected} = this.props;
        // const dataColumns = data.columns;
        // const dataRows = data.rows;
        return (
            <div>
                <div className='table-responsive'>
                    <table className={'table employees'} id={id}>
                        <THead columns={dataColumns} />
                        <TBody
                            rows={dataRows}
                            columns={dataColumns}
                            tableId={id}
                            keyRow={keyRow}
                            onSelectedRow={onSelectedRow}
                            rowsSelected={rowsSelected}
                        />
                    </table>
                </div>
            </div>
        )
    }
};

export default Table;
